export const SITE_NAME = 'CaptureScreen';
export const SUPPORT_EMAIL = 'helloCaptureScreen@gmail.com';